import PropTypes from 'prop-types';
import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';

import { Vehicle } from '@sm360/widget-commons-vehicle';

import Certification from '../Certification/Certification.jsx';

const { VehicleModelV25, CertificationIconService: getCertificationIcon } = Vehicle;

const Badges = ({
    certifiedText,
    inspectedText,
    tradedText,
    warrantyText,
    warrantyBadge,
    certifiedBadge,
    inspectedBadge,
    tradedBadge,
    vehicle,
    showCarfax,
}) => {
    if (!vehicle || !(vehicle instanceof VehicleModelV25)) return null;

    const certificationIcon = getCertificationIcon(vehicle?.getMake());
    const hasCertifiedFlag = vehicle?.certified && certifiedText && certifiedText !== '';
    const certifiedTag =
        certificationIcon && !certifiedBadge ? (
            <img className="certification__image" alt={certifiedText} src={certificationIcon} />
        ) : (
            <Certification
                extraClasses="certified-no-icon"
                certificationText={certifiedText}
                certificationBadge={certifiedBadge}
            />
        );
    const { BadgesImageUrl: carfaxBadgeUrl } =
        (vehicle?.carfax?.BadgesList && vehicle?.carfax?.BadgesList.length > 0 && vehicle?.carfax?.BadgesList[0]) || {};
    const carfaxBadge = carfaxBadgeUrl && (
        <div>
            <img src={carfaxBadgeUrl} alt={LocaleService.t('CARFAX.TITLE')} />
        </div>
    );

    const hasTraded = vehicle?.asTraded &&
        tradedText &&
        tradedText !== '' && <Certification certificationText={tradedText} certificationBadge={tradedBadge} />;

    const hasWarranty = vehicle?.extendedWarranty &&
        warrantyText &&
        warrantyText !== '' && <Certification certificationText={warrantyText} certificationBadge={warrantyBadge} />;

    const isInspected = vehicle?.inspected &&
        inspectedText &&
        inspectedText !== '' && <Certification certificationText={inspectedText} certificationBadge={inspectedBadge} />;

    const hasCarfax = showCarfax && (
        <a
            className="carfax-icon"
            href={LocaleService.t('CARFAX.LINK', {
                make: vehicle?.getMake(),
                model: vehicle?.getModel(),
                year: vehicle?.year,
                trim: vehicle?.modelTrim?.name,
                stock: vehicle?.stockNumber,
                id: vehicle?.vehicleId,
            })}
        >
            <img
                className="carfax-image"
                alt={LocaleService.t('CARFAX.TITLE')}
                src="//s3.amazonaws.com/fs-sm360/var/images/sm360/icone/carproof_badge.png"
            />
        </a>
    );

    const badgingSection = carfaxBadgeUrl ? (
        <div className="certification-badge-carfax">
            {hasCertifiedFlag && certifiedTag}
            {(hasTraded || hasWarranty || isInspected) && (
                <div className="certification-badge-section">
                    {hasTraded}
                    {hasWarranty}
                    {isInspected}
                </div>
            )}
            <div className="carfax-badge-img">{carfaxBadge}</div>
        </div>
    ) : (
        <div className="certification-badge">
            {hasCertifiedFlag && certifiedTag}
            {(hasCarfax || hasTraded || hasWarranty || isInspected) && (
                <div className="certification-badge-secondary">
                    {hasCarfax}
                    {hasTraded}
                    {hasWarranty}
                    {isInspected}
                </div>
            )}
        </div>
    );

    return <div className="vehicle-certification">{badgingSection}</div>;
};

Badges.propTypes = {
    certifiedText: PropTypes.string.isRequired,
    inspectedText: PropTypes.string.isRequired,
    tradedText: PropTypes.string.isRequired,
    warrantyText: PropTypes.string.isRequired,
    certifiedBadge: PropTypes.string.isRequired,
    inspectedBadge: PropTypes.string.isRequired,
    tradedBadge: PropTypes.string.isRequired,
    warrantyBadge: PropTypes.string.isRequired,
    vehicle: PropTypes.instanceOf(VehicleModelV25).isRequired,
    showCarfax: PropTypes.bool.isRequired,
};

Badges.displayName = 'Tile.Badges';

export default Badges;
